import classNames from 'classnames';
import './KSCheckbox.scss';
import { ChangeEvent } from 'react';
import { Tooltip } from '../KSQ2/Common';
import { IconPendoInfo } from '../../../components/Icons';

interface CheckOptionProps {
  rounded?: boolean;
  label: string;
  disabled?: boolean;
  checked: boolean;
  smallCaps?: boolean;
  tooltip?: string;
  showTooltipIcon?: boolean;
  colorLabel?: 'default' | 'gray';
  onChange: (checked: boolean) => void;
}

export default function KSCheckBox({
  rounded = false,
  checked,
  label,
  disabled,
  smallCaps,
  tooltip,
  showTooltipIcon,
  colorLabel = 'default',
  onChange,
}: CheckOptionProps) {
  const content = (
    <label className={classNames('ks-check-option', { rounded: rounded })}>
      <span
        className={classNames('label', {
          'is-disabled': disabled,
          'is-checked': checked,
          'small-caps': smallCaps,
          'gray-color': colorLabel === 'gray',
        })}
      >
        {label}
      </span>
      {showTooltipIcon && tooltip && (
        <Tooltip content={tooltip} position="top" alignment="center">
          <div className="info-icon-wrapper">
            <IconPendoInfo />
          </div>
        </Tooltip>
      )}
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
      />
      <span className={classNames('checkmark', { 'is-disabled': disabled })}></span>
    </label>
  );

  if (tooltip && !showTooltipIcon) {
    return (
      <Tooltip content={tooltip} position="top" alignment="center">
        {content}
      </Tooltip>
    );
  }

  return content;
}
